import { GET_PROFILE_DATA_SUCCESS } from "../types/profile";

export function profileReducer(
  state = { profileData: {}, reviewList: [] },
  action
) {
  switch (action.type) {
    case GET_PROFILE_DATA_SUCCESS: {
      const { DtData, Table2: reviewList = [] } = action.body;
      const [profileData] = DtData;
      return { ...state, profileData, reviewList };
    }

    default:
      return state;
  }
}
